export default __webpack_public_path__ + "static/media/big_sky_2.58abdbf4.jpg";